// 1. import `extendTheme` function
import { extendTheme } from "@chakra-ui/react";
// import "typeface-titillium-web";

// 2. Add your color mode config
//import { mode } from "@chakra-ui/theme-tools";

import Button from "./button";
import {checkboxTheme}  from "./checkbox";


const styles = {
  global: (props: any) => ({
    "*": {
      fontFamily: "Titillium Web",
      //color: mode("gray.800", "whiteAlpha.900")(props),
    },
    "body": {
      bg: 'gray.50'// mode('gray.50', 'gray.800')(props)
    },
    "a": {
      color: 'blue.400',
      _hover: {
        color: 'blue.600'
      }
    }
  }),
};
const themeConfig = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },

  colors: {
    primary: {
      100: "#06c",
      200: "#0059b3",
      300: "#004080",
    },
    pa:
    {
      50: '#def2ff',
      100: '#afd5ff',
      200: '#7eb9ff',
      300: '#4d9dff',
      400: '#2081fe',
      500: '#0968e5',
      600: '#0051b3',
      700: '#003a81',
      800: '#002350',
      900: '#000d20',
    },
  },

  components: {
    Button,
    Checkbox: checkboxTheme 
  },
  styles,
};

// 3. extend the theme
const theme = extendTheme(themeConfig);

export default theme;
